module.exports = __webpack_public_path__ + "img/hotpicklotto_yellow.6cc32c2c.png";